import axios from "axios";
import { API_AUTH } from "../../config";
// Create an axios instance for authenticated services

const axiosAuthInstance = axios.create({
  baseURL: API_AUTH,
  withCredentials: false,
});

axiosAuthInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("serviceToken");

    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

axiosAuthInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("serviceToken");
      localStorage.removeItem("isAuthenticated");
      window.location.href = "/login";
    }

    return Promise.reject(error);
  }
);

const callAuthAPI = async (options) => {
  try {
    // Merge headers, ensuring Content-Type is correctly set
    const headers = {
      ...options.headers,
    };

    // Remove Content-Type for FormData to allow axios to auto-set it
    if (options.data instanceof FormData) {
      delete headers["Content-Type"];
    }

    const axiosOptions = {
      ...options,
      headers,
    };

    // Make the API call
    // const { data } = await axiosAuthInstance(axiosOptions);
    // return data;
    const res  = await axiosAuthInstance(axiosOptions);
    return res;
  } catch (error) {
    if (error.response) {
      // Backend error response
      throw new Error(
        error.response.data.message ||
          error.response.data.error ||
          "An unknown error occurred"
      );
    } else if (error.request) {
      throw new Error("Could not connect to server");
    } else {
      throw new Error(error.message);
    }
  }
};

export { callAuthAPI };
